<template>

  <svg
    t="1641143491910"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4028"
    width="64"
    height="64"
  ><path d="M896 128H128c-25.6 0-42.666667 17.066667-42.666667 42.666667v682.666666c0 25.6 17.066667 42.666667 42.666667 42.666667h768c25.6 0 42.666667-17.066667 42.666667-42.666667V170.666667c0-25.6-17.066667-42.666667-42.666667-42.666667z m-42.666667 682.666667H170.666667V213.333333h682.666666v597.333334z" p-id="4029" /><path d="M170.666667 469.333333h682.666666v85.333334H170.666667v-85.333334z" p-id="4030" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconLayoutRow',
} as DefineComponent
</script>